import { useDataChange, useDataValue } from 'Simple/Data'
import addMonths from 'date-fns/addMonths'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let selected_slot = useDataValue({
    context: 'selected_slot',
    viewPath: props.viewPath,
  })

  let skip = useDataValue({
    context: 'widget',
    path: 'settings.skipMonthIfNoSlots',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected_slot',
    viewPath: props.viewPath,
  })

  return async function onChange(value) {
    let currentDate = new Date()

    // we only want to skip this month other wise it will continu moving through months
    // but here may be a case where ther eare no slots
    if (!skip || selected_slot.month.getMonth() !== currentDate.getMonth())
      return

    // check whether we have slots for this month
    let hasCurrentMonthSlots =
      (value &&
        Object.keys(value).filter(date => {
          let [year, month] = date.split('-')

          return (
            `${year}${month}` ===
            `${currentDate.getFullYear()}${String(
              new Date().getMonth() + 1
            ).padStart(2, '0')}`
          )
        })) ||
      []

    if (hasCurrentMonthSlots?.length === 0) {
      change(next => {
        next.month = addMonths(selected_slot.month, 1)
      })
    }
  }
}
